import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface AlertNotificationProps {
  show: boolean;
  variant: "default" | "destructive" | "success" | "warning";
  title: string;
  message: string;
  onClose: () => void;
}

export function AlertNotification({
  show,
  variant,
  title,
  message,
  onClose,
}: AlertNotificationProps) {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        zIndex: 9999,
        maxWidth: "min(400px, calc(100vw - 32px))",
        animation: "slideIn 0.3s ease-out",
      }}
    >
      <Alert variant={variant}>
        <AlertTitle>{title}</AlertTitle>
        <AlertDescription>{message}</AlertDescription>
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "8px",
            right: "8px",
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            opacity: 0.6,
          }}
          aria-label="Close alert"
        >
          ×
        </button>
      </Alert>
    </div>
  );
}
